<template>
  <div 
  :class="topNavList.length <= 5 ? 'needflatten': ''"
  style="
  display: flex;
  align-items: center;
  width: calc(100% - 0.2rem);
  overflow-x: scroll;
  margin: 0.1rem;
  ;">
    <div class="optionBox" v-for="item in topNavList" @click="goUrl(item)">
      <img
        :src="item.img"
        style="width: 1.1rem;height: 1.1rem;"
      ></img>
      <div
        class="optionText"
        :style="{backgroundColor: item.nameColor}"
      >
        {{ item.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuickOptions',
  data() {
    return {
     topNavList:this.$store.state.config.top_nav_list
    };
  },
  methods:{
    goUrl(item){
      this.$router.push({name: item.jump_url,});
    }
  }
};
</script>

<style scoped>
.needflatten{
  justify-content:space-between;
  align-items: center;
}
.optionBox{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 1.1rem;
  height: 1.1rem;
  position: relative;
  margin-left: 5px;
  margin-right: 5px;
  .optionText{
    position: absolute;
    color: #fff;
    max-width: 1.1rem;
    min-width:0.5rem;
    font-size: 0.18rem;
    text-align: center;
    line-height: 1.1;
    text-align: center;
    word-break: break-all;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    vertical-align: middle;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    padding: 0.05rem;
    border-radius: 50px;
    bottom: 0;
}
}

</style>
